import { WebsiteHeaderPhotoSchema_VideoArch_v1_1_1 } from '@apps/guest/websiteHeader';

export const VIDEO_ARCH_v1_1_1: WebsiteHeaderPhotoSchema_VideoArch_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoArch-v1_1_1.json',
  presentationLayout: 'videoArch',
  photos: [],
  video: undefined,
};
